export const isProd = () => {
  return process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID === "newie-production"
}

export const isNotProd = () => {
  return process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID !== "newie-production"
}
